'use client';

import { ReactNode, useEffect, useEffectEvent, useState } from 'react';

type Props = {
  breakpoint: string;
  defaultComponent: ReactNode;
  breakpointComponent: ReactNode;
};

function MatchMedia(props: Props) {
  const { breakpoint, defaultComponent, breakpointComponent } = props;

  const [matches, setMatches] = useState('default');

  const handleBreakpoint = useEffectEvent((e: MediaQueryListEvent | MediaQueryList) => {
    if (e.matches) {
      setMatches(breakpoint);
    } else {
      setMatches('default');
    }
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(breakpoint);

    mediaQuery.addEventListener('change', handleBreakpoint);
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleBreakpoint(mediaQuery);

    return () => {
      mediaQuery.removeEventListener('change', handleBreakpoint);
    };
  }, [breakpoint]);

  return matches === 'default' ? defaultComponent : breakpointComponent;
}

export default MatchMedia;
